import { timeStamp } from 'console';
import { cachedDataVersionTag } from 'v8';
import { appService } from '../common/AppService';
import * as common from '../common/Common';
import { Message } from './Model';

export class KeyboardViewModel {
    private shouldSendReturn = false;
    private shouldSendType = false;
    private processedIDs: { [id: string]: boolean } = {};
    private processedClearIDs: { [id: string]: boolean } = {};
    private sendMessageTimer: any = null;
    private receiveMessageTimer: any = null;
    private messageHistory: string[] = [];
    private messageHistoryIndex = 0;

    private lastMessageJsonText = '';

    public skipUIBindingProperties = ['sendMessageTimer', 'receiveMessageTimer'];

    public content = '';
    public isBusy = false;

    public isLoading = true;

    public uiLocation = 'main'
    public keyboardCode = '';
    public setFocus: () => void;

    public initialize() {
        appService.onRequireKeyboardCode.listen(() => {
            this.showGenerate();
        });

        if (appService.uiLocation == 'code') {
            this.uiLocation = appService.uiLocation;
        }

        appService.locationChanged.listen(() => {
            if (appService.uiLocation == 'home') {
                this.uiLocation = 'main';
            }
            if (appService.uiLocation == 'code') {
                this.uiLocation = appService.uiLocation;
            }
        });

        common.callHttp('GET', 'keyboard/code').then((result: any) => {
            this.keyboardCode = result;
            this.isLoading = false;
            this.setFocus();

            this.clearMessage();
            this.doSendMessage();
            this.doReceiveMessage();
        }, error => {
        });
    }

    public destroy() {
        clearTimeout(this.sendMessageTimer);
        clearTimeout(this.receiveMessageTimer);
    }

    public goBack() {
        this.uiLocation = 'main';
    }

    public showGenerate() {
        this.uiLocation = 'code';
    }

    public generateKeyboardCode() {
        appService.showMessage('Working on it...');
        common.callHttp('POST', 'keyboard/code').then((result: any) => {
            this.keyboardCode = result;
            appService.closeMessage();
        }, error => {
            appService.closeMessage();
        });
    }

    public onKeyDown(event: React.KeyboardEvent<HTMLTextAreaElement>) {
        if (event.shiftKey && event.key == 'Enter') {
            event.preventDefault();
        }
    }

    public onKeyUp(event: React.KeyboardEvent<HTMLTextAreaElement>) {
        let handleTimeout = false;

        if (event.ctrlKey && event.key == 'Enter') {
            this.shouldSendReturn = true;
            appService.showMessage('Sending...');
            this.isBusy = true;
            handleTimeout = true;
        }

        if (event.shiftKey && event.key == 'Enter') {
            this.shouldSendType = true;
            appService.showMessage('Sending...');
            this.isBusy = true;
            handleTimeout = true;
        }

        /* if (handleTimeout) {
            setTimeout(() => {
                if (this.isBusy) {
                    this.isBusy = false;
                    this.lastMessageJsonText='';
                    this.setFocus();
                    this.shouldSendReturn=false;
                    this.shouldSendType=false;
                    appService.showQuickMessage('Operation time out!', 2000);
                }
            }, 5000);
        } */
    }

    public goToPreviousMessage() {
        if (this.messageHistory.length > 0) {
            this.messageHistoryIndex--;
            if (this.messageHistoryIndex < 0) {
                this.messageHistoryIndex = 0;
            }

            this.content = this.messageHistory[this.messageHistoryIndex];
        }
    }

    public goToNextMessage() {
        if (this.messageHistory.length > 0) {
            this.messageHistoryIndex++;
            if (this.messageHistoryIndex > this.messageHistory.length - 1) {
                this.messageHistoryIndex = this.messageHistory.length - 1;
            }
            this.content = this.messageHistory[this.messageHistoryIndex];
        }
    }

    public sendContent(content: string) {
        this.content = content;
    }

    private doSendMessage() {
        this.sendMessageTimer = setTimeout(() => {
            let newMessage: Message = {
                data: this.content,
                command: '',
                id: common.generateUID()
            };

            if (this.shouldSendReturn) {
                newMessage.command = 'sendreturn';
            }
            if (this.shouldSendType) {
                newMessage.command = 'sendtype';
            }

            let newMessageJsonText = JSON.stringify({ ...newMessage, id: '' });
            if (newMessageJsonText != this.lastMessageJsonText) {
                this.lastMessageJsonText = newMessageJsonText;

                common.callHttp('POST', 'keyboard/message/mobile', {
                    Code: this.keyboardCode,
                    Data: JSON.stringify(newMessage)
                }).then(() => {
                    this.doSendMessage();
                });
            } else {
                this.doSendMessage();
            }
        }, 1000);
    }

    private doReceiveMessage() {
        this.receiveMessageTimer = setTimeout(() => {
            common.callHttp('GET', 'keyboard/message/desktop/' + this.keyboardCode).then(data => {
                if (data) {
                    let message = JSON.parse(data.toString()) as Message;

                    if (!this.processedIDs[message.id]) {
                        this.processedIDs[message.id] = true;
                        switch (message.command) {
                            case 'clear':
                                if (!this.processedClearIDs[message.data]) {
                                    this.processedClearIDs[message.data] = true;

                                    if (this.content == this.messageHistory[this.messageHistoryIndex]) {
                                        this.messageHistory.splice(this.messageHistoryIndex, 1);
                                    }
                                    this.messageHistory.push(this.content);
                                    this.messageHistoryIndex = this.messageHistory.length;

                                    this.content = '';
                                    this.shouldSendReturn = false;
                                    this.shouldSendType = false;
                                    setTimeout(() => {
                                        appService.closeMessage();
                                        this.isBusy = false;
                                        this.setFocus();
                                    });
                                } else {
                                    console.log('Duplicated ID: ' + message.data);
                                }
                                break;
                        }
                    }
                }
                this.doReceiveMessage();
            });
        }, 1000);
    }

    private clearMessage() {
        common.callHttp('DELETE', 'keyboard/message/desktop/' + this.keyboardCode);
    }
}